import { IClientComponentDefinition } from '@glidecms/deliver-core-dev/gd-module'

export const WBreadcrumbCCD: IClientComponentDefinition = {
  name: 'WBreadcrumb ',
  load: () => import(/* webpackChunkName: 'WBreadcrumb' */ './index'),
}
